import { render } from "./LoadingView.vue?vue&type=template&id=027f6c89&scoped=true"
import script from "./LoadingView.vue?vue&type=script&lang=js"
export * from "./LoadingView.vue?vue&type=script&lang=js"

import "./LoadingView.vue?vue&type=style&index=0&id=027f6c89&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027f6c89"]])

export default __exports__